const retailProducts = [
  {
    id: 1,
    name: 'Kashmiri Saffron',
    category: 'Saffron',
    description: 'Premium Kashmiri saffron strands with deep crimson color, floral aroma, and a rich infusion ideal for desserts, biryanis, milk beverages, and festive recipes.',
    image: '/img/ks1.jpg',
    images: [
      '/img/ks1.jpg',
      '/img/ks2.jpg'
    ],
  },
  {
    id: 2,
    name: 'Ginger Powder',
    category: 'Ginger',
    description: 'Finely ground dry ginger powder with warm, zesty notes that works well in curries, marinades, chai blends, baked goods, and traditional home remedies.',
    image: '/img/gp1.jpg',
    images: [
      '/img/gp1.jpg',
      '/img/gp2.jpg',
      
    ],
  },
  {
    id: 3,
    name: 'Posto / Khas Khas',
    category: 'Seeds & Spices',
    description: 'Clean and fresh poppy seeds with a mild nutty taste, perfect for rich gravies, Bengali-style pastes, dessert toppings, and texture in baked preparations.',
    image: '/img/kk1.jpg',
    images: [
      '/img/kk1.jpg',
      '/img/kk2.jpg',
    ],
  },
  {
    id: 4,
    name: 'Himalayan Haldi',
    category: 'Turmeric',
    description: 'Aromatic Himalayan turmeric known for vibrant color and earthy flavor, suitable for daily cooking, golden milk, spice blends, and wellness-focused recipes.',
    image: '/img/tp1.jpg',
    images: [
      '/img/tp1.jpg',
      '/img/tp2.jpg',
      
    ],
  },
  {
    id: 5,
    name: 'Red Chilli Powder',
    category: 'Chilli',
    description: 'Bright red chilli powder with balanced heat and robust flavor, crafted to add color, pungency, and depth to curries, snacks, and seasoning mixes.',
    image: '/img/cp2.jpg',
    images: [
      '/img/cp2.jpg',
      '/img/cp1.jpg',
    ],
  },
  {
    id: 6,
    name: 'Cumin',
    category: 'Seeds & Spices',
    description: 'Fragrant cumin with warm, earthy notes and a slightly peppery finish, essential for tempering, masalas, rice dishes, lentils, and roasted spice blends.',
    image: '/img/cc1.jpg',
    images: [
      '/img/cc1.jpg',
      '/img/cc2.jpg',
    ],
  },
  {
    id: 7,
    name: 'Coriander',
    category: 'Seeds & Spices',
    description: 'Fresh coriander spice offering citrusy, mildly sweet notes that enhance curries, chutneys, marinades, pickles, and all-purpose Indian seasoning mixes.',
    image: '/img/co1.jpg',
    images: [
      '/img/co1.jpg',
      '/img/co2.jpg',
    ],
  },
  {
    id: 8,
    name: 'Green Cardamom',
    category: 'Cardamom',
    description: 'Premium green cardamom pods with sweet herbal aroma and strong essential oils, ideal for chai, desserts, biryani, kheer, and festive sweets.',
    image: '/img/gc1.jpg',
    images: [
      '/img/gc1.jpg',
      '/img/gc2.jpg',
    ],
  },
  {
    id: 9,
    name: 'Black Cardamom',
    category: 'Cardamom',
    description: 'Bold black cardamom with a smoky, resinous profile that adds depth to rich gravies, slow-cooked dals, pulao, and hearty North Indian dishes.',
    image: '/img/bc1.jpg',
    images: [
      '/img/bc1.jpg',
      '/img/bc2.jpg',
    ],
  },
  {
    id: 10,
    name: 'Black Pepper Powder',
    category: 'Seeds & Spices',
    description: 'Aromatic black pepper powder with sharp heat and woody notes, suitable for soups, stir-fries, marinades, egg dishes, and table-top seasoning.',
    image: '/img/bpp1.jpg',
    images: [
      '/img/bpp1.jpg',
      '/img/bpp2.jpg',
    ],
  },
  // {
  //   id: 11,
  //   name: 'Chaap Masala',
  //   category: 'Masala',
  //   description: 'Specialty chaap masala blend designed for grilled and tandoori-style preparations, delivering savory warmth, layered spice, and restaurant-style finish.',
  //   image: '/img/retail/chaap-masala.jpg',
  //   images: [
  //     '/img/retail/chaap-masala.jpg',
  //     'https://picsum.photos/seed/retail-chaap-masala-1/1200/800',
  //     'https://picsum.photos/seed/retail-chaap-masala-2/1200/800',
  //   ],
  // },
  // {
  //   id: 12,
  //   name: 'Pindi Chola Masala',
  //   category: 'Masala',
  //   description: 'Classic Pindi chola masala blend with tangy, earthy, and spicy notes that gives chickpea dishes an authentic Punjabi taste and dark rich gravy profile.',
  //   image: '/img/retail/pindi-chola-masala.jpg',
  //   images: [
  //     '/img/retail/pindi-chola-masala.jpg',
  //     'https://picsum.photos/seed/retail-pindi-chola-masala-1/1200/800',
  //     'https://picsum.photos/seed/retail-pindi-chola-masala-2/1200/800',
  //   ],
  // },
  // {
  //   id: 13,
  //   name: 'Kadhai Masala',
  //   category: 'Masala',
  //   description: 'Robust kadhai masala mix crafted for onion-tomato based gravies, adding roasted spice aroma and bold flavor to paneer, vegetables, and chicken recipes.',
  //   image: '/img/retail/kadhai-masala.jpg',
  //   images: [
  //     '/img/retail/kadhai-masala.jpg',
  //     'https://picsum.photos/seed/retail-kadhai-masala-1/1200/800',
  //     'https://picsum.photos/seed/retail-kadhai-masala-2/1200/800',
  //   ],
  // },
  // {
  //   id: 14,
  //   name: 'Garam Masala',
  //   category: 'Masala',
  //   description: 'Traditional garam masala featuring warming whole-spice notes, ideal as a finishing spice for curries, dals, kebabs, and everyday Indian cooking.',
  //   image: '/img/retail/garam-masala.jpg',
  //   images: [
  //     '/img/retail/garam-masala.jpg',
  //     'https://picsum.photos/seed/retail-garam-masala-1/1200/800',
  //     'https://picsum.photos/seed/retail-garam-masala-2/1200/800',
  //   ],
  // },
  // {
  //   id: 15,
  //   name: 'Ahuna Masala',
  //   category: 'Masala',
  //   description: 'Regional-style Ahuna masala blend with deep roasted character, created to enrich slow-cooked meat and vegetable curries with intense, lingering flavor.',
  //   image: '/img/retail/ahuna-masala.jpg',
  //   images: [
  //     '/img/retail/ahuna-masala.jpg',
  //     'https://picsum.photos/seed/retail-ahuna-masala-1/1200/800',
  //     'https://picsum.photos/seed/retail-ahuna-masala-2/1200/800',
  //   ],
  // },
];

export default retailProducts;
